<!--
 Desarrollado por: Wuilmer garcia
// Fecha: 2020_06-25
// Modificado por: Wuilmer Garcia
// Fecha de ultima Modificación:
// Causa: Anexo de usuarios a formulario de Colegio


Historial de Modificaciones
// Fecha Modificación: 2020/06/25
// Modificación: Anexo de usuarios a formulario de Colegio

///////////////////////////////////////////////////////////
-->

<template>
  <div>
    <!-- formulario de Configuracion de Colegio -->
    <mensajeSistema></mensajeSistema>
    <v-form ref="formColegioConfig" lazy-validation>
      <v-dialog v-model="modalConfig" persistent scrollable max-width="90%">
        <v-card>
          <v-card-title class="btn_otro">
            <span class=""> Configuración de colegio</span>
            <v-spacer />
            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
          </v-card-title>

          <v-divider />

          <v-card-text>
            <div class="my-2">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete label="Colegio" v-model="configuracion.id_colegio" :items="[colegios]"
                    @change="cargarSubModulo" item-value="id" item-text="nombre_colegio" autocomplete="off">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete label="Tipo de licencia" v-model="configuracion.id_licencia_tipo"
                    :items="licenciaTipo" @change="cargarSubModulo" item-value="id" item-text="desc_tipo_licencia"
                    :rules="[rul.selectReq]" autocomplete="off">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-select v-model="configuracion.id_modulo" :items="modulo" label="Módulo" @change="cargarSubModulo"
                    item-value="id" item-text="nombre_modulo" :rules="[rul.selectReq]">
                  </v-select>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12" md="6" sm="6" xs="12" class="d-none d-sm-flex px-3">
                <label class="font-weight-black black--text">
                  <h3>Submódulos</h3>
                </label>
                <v-spacer />
                <v-icon small class="black--text">fa-handshake</v-icon>
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="12" class="d-flex px-3">
                <label class="font-weight-black black--text">
                  <h3>Submódulos</h3>
                </label>
                <v-spacer />
                <v-icon small class="black--text">fa-handshake</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" v-for="item in this.confSubModulo" :key="item.id"
                class="my-2 py-0">
                <v-row>
                  <v-col cols class="px-3 py-0">
                    <label class="black--text">{{
                      item.nombre_submodulo
                    }}</label>
                  </v-col>
                  <v-col cols="1" class="py-0">
                    <div class="d-flex justify-center">
                      <v-checkbox class="px-3 my-0" v-model="confSubModuloCheck" :value="item.id" color="indigo"
                        hide-details>
                      </v-checkbox>
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="mt-3"></v-divider>
              </v-col>
            </v-row>
          </v-card-text>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark @click="$emit('close')">Cancelar</v-btn>
            <v-btn class="btn_block_style2" dark @click="saveConfig">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- fin modal cargar archivo -->
  </div>
</template>

<script>
//

import axios from "../../../../helpers/axios";
// eslint-disable-next-line
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "modalColegioConfiguracion",

  props: ["modalConfig", "parametros"],

  data: () => ({
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    // Configuracion de colegio ////
    configuracion: {},
    licenciaTipo: [],
    confSubModulo: [],
    confSubModuloCheck: [],
    modulo: [],
    colegios: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
  }),

  mounted() {
    //this.listarTemas();
    this.loadMain();
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    modalConfig: function () {
      if (this.modalConfig) {
        this.loadMain();
      } else {
        // this.parametros = {};
        this.limpiarForm();
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    ////////////////////////////////////////////////////////

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      this.limpiarForm();

      try {
        this.configuracion.id_modulo = null;
        this.configuracion.id_licencia_tipo = null;
        this.confSubModulo = [];
        this.confSubModuloCheck = [];

        this.colegios = this.parametros;
        this.configuracion.id_colegio = this.parametros.id;
        this.getModulo(this.parametros.id);
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: e, tiempo: null });
      }
    },

    async getModulo(id) {
      try {
        let response = await axios.get(`/sistema/modeloNegocio/modulo/${id}`);
        this.modulo = response.data.modulo;
        this.licenciaTipo = response.data.licenciaTipo;

        // {licenciaTipo, modulo }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error)
      }
    },

    async cargarSubModulo() {
      if (
        this.configuracion.id_colegio != null &&
        this.configuracion.id_licencia_tipo != null &&
        this.configuracion.id_modulo != null
      ) {
        try {
          this.confSubModulo = [];
          this.confSubModuloCheck = [];
          let response = await axios.post(
            "/sistema/modeloNegocio/modeloNegocioConfig",
            this.configuracion
          );

          console.log('revisa',response);

          this.confSubModulo = response.data.subModulo;
          this.confSubModuloCheck = response.data.confModeloNegocioCheck;
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

  async saveConfig() {
    if (this.$refs.formColegioConfig.validate()) {
      try {
        let params = {
          configuracion: this.configuracion,
          confSubModuloCheck: this.confSubModuloCheck,
          id_usuario: this.datoLogin.id,
        };
        const res = await axios.post(
          "/sistema/modeloNegocio/saveConfig",
          params
        );
        console.log(res);
        this.setEnviarMens({
          tipo: "S",
          mensaje: "¡Registro guardado con éxito.!",
          tiempo: null,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: 9999999 });
      }
    }
  },

    limpiarForm() {
      this.configuracion = {
        id_colegio: "",
        id_licencia_tipo: "",
        id_modulo: "",
      };

      this.$refs.formColegioConfig.resetValidation();
    },
  },
};
</script>
